/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Link } from 'components/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Deux semaines après sa naissance, Erika est placée avec d’autres veaux dans le parc à veaux et reçoit dans les muscles de sa cuisse arrière une injection de Xylazine, un sédatif destiné à apaiser ses douleurs. Dix minutes après la piqûre, le paysan pose pendant quelques quinze secondes une barre de fer chaud pour brûler les racines de corne. Comme Erika, 90% des veaux suisses subissent un écornage. Erika risque ainsi moins de se blesser ou de blesser d’autres bêtes. Toutefois, elle souffre pendant l’intervention et durant plusieurs jours par la suite, comme l’a démontré une étude non publiée de l’Université de Berne.`}</p>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  